import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/Header";

// Páginas
import Inicio from "./pages/Inicio";
import Planes from "./pages/Planes"; 
import Servicios from "./pages/Servicios";
import Nosotros from "./pages/Nosotros";
import Contacto from "./pages/Contacto";
import SpeedTest from "./pages/SpeedTest";

function Analytics() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-FRY8YCPH3Q', {
        page_path: location.pathname,
      });
    }
  }, [location]);
  return null;
}

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Header />
        <Analytics />
        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/planes" element={<Planes />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/speed-test" element={<SpeedTest />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;